//import { AccountFeature, AccountPlanConfig } from "../billing/BillingAccountInfo";

export class Schooladminitem {
    targetUsername:string;
    isEnabled:boolean;
    schoolID:number;
}

export class SchoolInfoBundle{
    schoolInfo: SchoolViewModel = new SchoolViewModel();
    schoolConfig: SchoolConfig = new SchoolConfig();
}

export class SchoolConfig{    
    // domainCustomization:string;
    // logoCustomization:string;
    // mediaStorageSize:number;
    //studentCountMax:number;
    hourstoexpire:number;
    domain:string;
    daytoexpire:number;
    enddate_string:string;
    tierid:number;    
    plan: AccountPlanConfig = new AccountPlanConfig();
    //features: Map<number, AccountFeature>;
  }

  export class SchoolViewModel{
    id: number;
    schoolName: string;
    schoolEmail: string;
    schoolNumber: string;
    schoolOwnerId: string;
    schoolSubdomain: string;
    schoolDescription: string;
    studentsCanEnrollForModules: boolean;
    studentsCanEnrollForPackages: boolean;
    privateSchool: boolean;
    allowTutorSendMail: boolean;
    accountTierId: number;
    //public long VCircleAccountTierId { get; set; }
    freePlanSelected: boolean;
    accountName: string;
    accountNumber: string;
    bankId: number;
    bank: string;
    logoImg: string;
    logoutURL: string;
    loginURL: string;
    invoiceEmail: string;
    hideFeesForFreeCourses: boolean;
    subdomain: string;
  }

  export class AccountFeature{
    constructor(){};
    id: number;
    name: string;
    description: string;
    featureMinimum: number;
    featureMaximum: number;
    featureGroup: number;
    sNo: number;
    display: boolean;
    minimumTierSNo: number
  }

export class AccountPlanConfig{
    constructor(){};
    id:number; // public long ID { get; set; }
    name:string;
    display: boolean;
    disableFeaturesIfOwing: boolean;
    sNo: number;
    free: boolean;
    nairaPricePerStudent: number;
    altPriceText: string;
    allowUserSelect: boolean;
    features: any;
}

export class FeatureGroups{
    static NUMBER_OF_COURSES = 1;
    static ADMINISTRATORS_TUTORS = 2;
    static YOUTUBE_VIMEO_VIDEOS = 3;
    static STUDENT_COUNT = 4;
    static ASSESSMENTS = 5;
    static E_COMMERCE = 6;
    static PERSONALISED_SUBDOMAIN = 7;
    static NOTIFICATIONS_EMAILS = 8;
    static EVENTS = 9;
    static STUDENT_BULK_UPLOAD = 10;
    static FREE_MONTHS = 11;
    static MEDIA_LIBRARY = 12;
    static SITE_CUSTOMISATION = 13;
    static API_INTEGRATION = 14;
    static CUSTOM_DOMAIN = 15;
}